import mdlProduct from '@/models/Warehouse/WhProduct'
import {
    generateDeleteItemFunction,
    getFetchDataFunction,
} from '../DataTableService'
const route = process.env.VUE_APP_API_ROUTE + '/wh_product?filter[type]=item'

const includes = ['sl_wholesale_discounts']
const appends = ['sale_prices', 'stocks', 'branch_offices']

const dtFetchData = getFetchDataFunction(route, includes, appends)
const dtDeleteItem = generateDeleteItemFunction(mdlProduct)

// If we need a custom route for the show and edit view:
// const showEditRoute = 'custom_route'

export default {
    dtFetchData,
    dtDeleteItem,
    //showEditRoute
}
